import { render, staticRenderFns } from "./DataPropertyDefinitionDescriptorPopover.vue?vue&type=template&id=20d74918&scoped=true&"
import script from "./DataPropertyDefinitionDescriptorPopover.vue?vue&type=script&lang=ts&"
export * from "./DataPropertyDefinitionDescriptorPopover.vue?vue&type=script&lang=ts&"
import style0 from "./DataPropertyDefinitionDescriptorPopover.vue?vue&type=style&index=0&id=20d74918&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d74918",
  null
  
)

export default component.exports